var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconProofOfConcept = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 17,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    fill: "none",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 8.5V4.33267C13.3334 4.28005 13.323 4.22793 13.3029 4.17931C13.2828 4.13069 13.2532 4.08652 13.216 4.04934L11.1173 1.95067C11.0424 1.87563 10.9407 1.83343 10.8347 1.83334H3.06666C2.96057 1.83334 2.85883 1.87548 2.78381 1.95049C2.7088 2.02551 2.66666 2.12725 2.66666 2.23334V14.7667C2.66666 14.8728 2.7088 14.9745 2.78381 15.0495C2.85883 15.1245 2.96057 15.1667 3.06666 15.1667H7.33332M5.33332 7.16667H10.6667M5.33332 4.5H7.99999M5.33332 9.83334H7.33332",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 1.83334V4.1C10.6667 4.20609 10.7088 4.30783 10.7838 4.38285C10.8588 4.45786 10.9606 4.5 11.0667 4.5H13.3333M10.8707 11.9087L11.4767 10.624C11.493 10.5873 11.5197 10.5561 11.5534 10.5342C11.5871 10.5123 11.6265 10.5006 11.6667 10.5006C11.7069 10.5006 11.7462 10.5123 11.7799 10.5342C11.8137 10.5561 11.8403 10.5873 11.8567 10.624L12.4633 11.9087L13.818 12.116C13.992 12.1427 14.0613 12.3667 13.936 12.4947L12.9553 13.4947L13.1867 14.9067C13.216 15.088 13.034 15.2267 12.8787 15.1407L11.6667 14.474L10.4547 15.1407C10.2987 15.2267 10.1173 15.088 10.1467 14.9067L10.378 13.4947L9.39801 12.4947C9.27135 12.3667 9.34134 12.1427 9.51534 12.116L10.8707 11.9087Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 17,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    fill: fill,
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 8.5V4.33267C13.3334 4.28005 13.323 4.22793 13.3029 4.17931C13.2828 4.13069 13.2532 4.08652 13.216 4.04934L11.1173 1.95067C11.0424 1.87563 10.9407 1.83343 10.8347 1.83334H3.06666C2.96057 1.83334 2.85883 1.87548 2.78381 1.95049C2.7088 2.02551 2.66666 2.12725 2.66666 2.23334V14.7667C2.66666 14.8728 2.7088 14.9745 2.78381 15.0495C2.85883 15.1245 2.96057 15.1667 3.06666 15.1667H7.33332M5.33332 7.16667H10.6667M5.33332 4.5H7.99999M5.33332 9.83334H7.33332",
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 1.83334V4.1C10.6667 4.20609 10.7088 4.30783 10.7838 4.38285C10.8588 4.45786 10.9606 4.5 11.0667 4.5H13.3333M10.8707 11.9087L11.4767 10.624C11.493 10.5873 11.5197 10.5561 11.5534 10.5342C11.5871 10.5123 11.6265 10.5006 11.6667 10.5006C11.7069 10.5006 11.7462 10.5123 11.7799 10.5342C11.8137 10.5561 11.8403 10.5873 11.8567 10.624L12.4633 11.9087L13.818 12.116C13.992 12.1427 14.0613 12.3667 13.936 12.4947L12.9553 13.4947L13.1867 14.9067C13.216 15.088 13.034 15.2267 12.8787 15.1407L11.6667 14.474L10.4547 15.1407C10.2987 15.2267 10.1173 15.088 10.1467 14.9067L10.378 13.4947L9.39801 12.4947C9.27135 12.3667 9.34134 12.1427 9.51534 12.116L10.8707 11.9087Z",
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});
export default SvgIconProofOfConcept;
export const raw = __webpack_public_path__ + "static/media/icon-proof-of-concept.035463513464d0cc3a00c6613c82d6f5.svg";